import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// services
import { AddProductsService } from '../../../../core/services/add-products.service';
import { NgxFileDropEntry } from 'ngx-file-drop';

@Component({
    selector: 'app-products-add-excel-modal',
    templateUrl: './products-add-excel-modal.component.html',
    styleUrls: ['./products-add-excel-modal.component.scss'],
    standalone: false
})

export class ProductsAddExcelModalComponent implements OnInit, OnDestroy {
	private listener: () => {};

	constructor(
        @Inject(MAT_DIALOG_DATA) public data: { params: any },
		private dialogRef: MatDialogRef<ProductsAddExcelModalComponent>,
		private service: AddProductsService,
		private ngZone: NgZone
	) { }

	ngOnInit(): void {
		this.listener = this.pasteArticles.bind(this);
		window.addEventListener('paste', this.listener);
	}

	close(): void {
		this.dialogRef.close(false);
	}

	async pasteArticles(event: Event): Promise<void> {
		const clipboardEvent = event as ClipboardEvent;
		let data: string | Array<string> = clipboardEvent.clipboardData.getData('text');

		const ARTICLE_REGEXP = /[a-zA-Zа-яА-Я\d\.\-]*[a-zA-Zа-яА-Я\d\.\-]+/g;

		data = data.match(ARTICLE_REGEXP) || [];

		if (!data.length) return this.dialogRef.close(false);

		const response: any = await this.service.getProductsByValues(data, this.data?.params || {});
		this.dialogRef.close({ products: response?.results?.products || [] });
	}

	uploadFile(droppedFiles: Array<NgxFileDropEntry>): void {
		if (droppedFiles?.[0]?.fileEntry?.isFile) {
			(droppedFiles[0].fileEntry as FileSystemFileEntry).file((file: File): void => {
				this.ngZone.run((): void => {
					this.dialogRef.close({ file: file });
				});
			});
		}
	}

	ngOnDestroy(): void {
		window.removeEventListener('paste', this.listener);
	}
}